export const basicDetailsImageUploadAvatarStyle = theme => ({
    avatar: {
        display: 'flex'
    },
    noImage: {
        background: 'grey',
        width: 100,
        height: 100
    },
    img: {
        width: '100%'
    },
    labelMarginReset: {
        marginTop: 0,
        marginBottom: 0,
        width: '100%'
    },
    hiddenDefaultUpload: {
        display: 'none'
    }
})